const NavigationSectionKey = Object.freeze({
    PLATFORM: 'platform',
    COURSEWORK: 'coursework',
    COGNITIVE: 'cognitive',
    UTILITY: 'utility',
});

const SECTION_LABELS = {
    [NavigationSectionKey.PLATFORM]: ['nav.platform', 'Platform'],
    [NavigationSectionKey.COURSEWORK]: ['nav.coursework', 'Coursework'],
    [NavigationSectionKey.COGNITIVE]: ['nav.cognitive-apprenticeship', 'Cognitive Apprenticeship'],
};

const SECTION_ORDER = [NavigationSectionKey.PLATFORM, NavigationSectionKey.COURSEWORK, NavigationSectionKey.COGNITIVE];

const getNavigableAssignments = (assignments, role) => {
    if (!Array.isArray(assignments)) return [];
    if (role !== 'student') return assignments;
    return assignments.filter(({ ai_student_feedback_enabled, is_draft }) => ai_student_feedback_enabled && !is_draft);
};

const getActiveAssignmentId = (pathname, assignments) => {
    const match = pathname?.match(/^\/assignments\/([^/]+)/);
    if (!match || match[1] === 'new') return null;
    return (assignments || []).some(({ id }) => String(id) === match[1]) ? match[1] : null;
};

const isActivePath = (pathname, link) => {
    if (!link) return false;
    return link === '/' ? pathname === '/' : pathname === link || pathname.startsWith(`${link}/`);
};

const getVisibleNavigationItems = (items, course) =>
    course ? items : items.filter((item) => item.section === NavigationSectionKey.PLATFORM);

export {
    getActiveAssignmentId,
    getNavigableAssignments,
    getVisibleNavigationItems,
    isActivePath,
    NavigationSectionKey,
    SECTION_LABELS,
    SECTION_ORDER,
};
